import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCutwise = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M24.001 46 9 24 24.001 2 39 24z" })
});
export default SvgCutwise;
